export default __webpack_public_path__ + "static/media/error-500.4fbe2b8f.png";